;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.invoice', [
      'kilo.routes.invoice.show',
      'kilo.routes.invoice.list'
    ])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    var parentState = {
      name: 'invoice',
      url: '/invoice',
      resolve: {},
      abstract: true
    }

    $stateProvider.state(parentState)
  }
})(window.angular)
